import { Component, Prop, Vue } from 'vue-property-decorator';
import ClTypography from '../ClTypography';
import { applyClasses } from '../../lib';

type Classes = {
  primary: any;
  secondary: any;
};

@Component({
  components: { ClTypography }
})
export default class ClListItemText extends Vue {
  @Prop({
    type: Object as () => Classes,
    default: () => ({
      primary: '',
      secondary: ''
    })
  })
  readonly classes!: Classes;

  @Prop(String)
  readonly primary!: string;

  @Prop({
    type: Object,
    default: () => ({})
  })
  readonly primaryProps!: object;

  @Prop(String)
  readonly secondary!: string;

  @Prop({
    type: Object,
    default: () => ({})
  })
  readonly secondaryProps!: object;

  get primaryClasses(): object {
    return applyClasses(
      'cl-list-item-text__primary',
      this.classes.primary,
      (this.primaryProps as any).class
    );
  }

  get secondaryClasses(): object {
    return applyClasses(
      'cl-list-item-text__secondary',
      this.classes.secondary,
      (this.secondaryProps as any).class
    );
  }

  get primaryComponent(): string {
    return (this.primaryProps as any).component || 'span';
  }
}
